import Axios from "axios";

export const SelectAllEcheanceClient = ( a, b, c, d, e) => {
  return (dispatch) => {
    const today = new Date();
    today.setFullYear(today.getFullYear() + 20);
    
    const datePlus2Ans = today.toISOString().slice(0, 10);
    Axios.get("https://www.24-crm.tn/webservice/api/Echeancecli", {
        params: {
          clideb: "+",
          clifin: "+",
          datdeb: "2000-01-14",
          datfin: datePlus2Ans,
          ModReg: "%",
          Banque: "%",
          Categ: "%",
          Region: "%",
          Rep: "%",
          Situation: "%",
          CodCCB: "%",
          NumCais: "%",
          coddos: a,
          serveur: b,
          user: c,
          pwd: d,
          database: e,
        },
      }).then((response) => {
        dispatch({ type: "EchRCLI_GET", payload: response.data });
      });
      
  };
};



// import Axios from "axios";

// export const SelectAllEcheanceClient = ( a, b, c, d, e,f,g,h,i,j,k,l,m,n,o,p,s) => {
//   return (dispatch) => {
//     Axios.get(
//       `https://www.24-crm.tn/webservice/api/Echeancecli?clideb=${a}&clifin=${b}&datdeb=${c}&datfin=${d}&ModReg=${e}&Banque=${f}&Categ=${g}&Region=${h}&Rep=${i}&Situation=${j}&CodCCB=${k}&NumCais=${l}&coddoss=${m}&serveur=${n}&user=${o}&pwd=${p}&database=${s}`
//     ).then((response) => {
//       return dispatch({ type: "EchRCLI_GET", payload: response.data });
//     });
//   };
// };